import { Color } from "@deck.gl/core"

export enum HotspotsLayerFilterTypes {
    // whatever default is in slice
    Default = "default",
    // hide all
    None = "none",
    // special combinations of different hotspot status combinations
    All = "all",
    Deleted = "deleted",
    Active = "active",
    // not in use currently, missing db fields to store this
    Out = "out",
    ActiveOrOut = "active-or-out",
}

// constants we can adjust to change how we display the hexmap for hotspots

// radius determines the size of the hexagons
export const hotspotHexagonRadius = 10
// color range determines the sliding scale of how a hotspots intensity maps to a color
export const hotspotHexagonColorRange: Color[] = [
    [80, 27, 67],
    [107, 28, 64],
    [134, 28, 61],
    [160, 34, 60],
    [187, 39, 59],
    [199, 73, 54],
    [211, 107, 49],
    [219, 130, 52],
    [227, 152, 56],
    [236, 176, 62],
    [245, 201, 68],
]
